var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"floating-button",style:(_vm.buttonStyle),on:{"click":_vm.onClick,"touchstart":_vm.onTouchStart,"touchmove":function($event){$event.preventDefault();return _vm.onTouchMove.apply(null, arguments)},"touchend":_vm.onTouchEnd}},[_c('Icon',{staticClass:"add-icon",attrs:{"name":"plus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }